import { ArchivedFilter, ProcessFilterZod } from "@avenueops/shared-types";
import { SignalIcon } from "@heroicons/react/24/outline";
import AuthenticatedLayout from "components/AuthenticatedLayout";
import ProcessTablePage from "components/ProcessTable/ProcessTableContextWrapper";
import { useOrganization } from "context/OrganizationContext";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { useIntercom } from "react-use-intercom";

interface Props {
  archived: ArchivedFilter;
}

export default function SignalsPage({ archived }: Props): JSX.Element {
  const { update } = useIntercom();

  const organization = useOrganization();
  const router = useRouter();
  const monitorId = router.query.monitorId ?? "";

  const {
    query: { filters },
  } = router;

  let processFilters: ProcessFilterZod[] = [];
  if (typeof filters === "string") {
    processFilters = [JSON.parse(filters)];
  } else {
    processFilters = filters?.map((filter) => JSON.parse(filter) as ProcessFilterZod) ?? [];
  }

  if (monitorId.length > 0) {
    processFilters.push({ type: "WORKFLOW", value: [monitorId] } as ProcessFilterZod);
  }

  useEffect(() => {
    update({
      hideDefaultLauncher: true,
    });

    return () => {
      update({
        hideDefaultLauncher: false,
      });
    };
  }, [update]);

  return (
    <AuthenticatedLayout fullScreen>
      <ProcessTablePage starterFilters={processFilters} archived={archived} isDashboard={false} />
    </AuthenticatedLayout>
  );
}
